import * as actionTypes from './actionTypes';
import API from '../../axios/api';
import { toastr } from 'react-redux-toastr'
import { i18n } from '../../translate/i18n';

export const fetchAreasSuccess = (areas) => {
  return {
    type: actionTypes.FETCH_AREAS_SUCCESS,
    areas: areas
  };
};

export const requestAreasFail = (error) => {
  return {
    type: actionTypes.REQUEST_AREAS_FAIL,
    error: error
  };
};

export const requestAreasStart = () => {
  return {
    type: actionTypes.REQUEST_AREAS_START
  };
};

export const deleteAreasSuccess = (area) => {
  return {
    type: actionTypes.DELETE_AREAS_SUCCESS,
    area: area
  }
}

export const checkDeleteAreasSuccess = (checkDelete) => {
  return {
    type: actionTypes.CHECK_DELETE_AREAS_SUCCESS,
    checkDelete: checkDelete
  }
}

export const updateAreasSuccess = (area) => {
  return {
    type: actionTypes.UPDATE_AREAS_SUCCESS,
    area: area
  }
}

export const postAreasSuccess = (area) => {
  return {
    type: actionTypes.POST_AREAS_SUCCESS,
    area: area
  }
}

export const fetchAreas = (page, limit, search, order, orderBy) => {

  return dispatch => {
    dispatch(requestAreasStart());
    const queryParams = `?page=${!page || page < 1 ? 1 : page}&limit=${!limit || limit < 5 ? 5 : limit}&q=${search ? search : ''}&sort=${order === 'desc' ? '-' : ''}${orderBy}`;
    API.get('/areas' + queryParams)
      .then(res => {
        dispatch(fetchAreasSuccess(res.data));
      })
      .catch(err => {
        dispatch(requestAreasFail(err));
      });
  };
};

export const deleteAreas = (index) => {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(requestAreasStart());
      API.put('/areas/' + index + '/delete')
        .then(res => {
          dispatch(deleteAreasSuccess(res.data));
          toastr.success(i18n.t('deleteAreasStr.toastr'), `${res.data.name} ${i18n.t('deleteAreasStr.toastr1')}`)
          resolve('success');
        })
        .catch(err => {
          dispatch(requestAreasFail(err));
          toastr.error('Erro', err.response.data.message)
          resolve('error');
        });
    })

  }
}

export const checkDeleteAreas = (index) => {
  return dispatch => {
    dispatch(requestAreasStart());
    API.get('/areas/' + index + '/checkdelete')
      .then(res => {
        console.log(res)
        dispatch(checkDeleteAreasSuccess(res.data));
      })
      .catch(err => {
        dispatch(requestAreasFail(err));
      });
  }
}

export const postAreas = (body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestAreasStart());
      API.post('/areas', body)
        .then(res => {
          dispatch(postAreasSuccess(res.data));
          toastr.success(i18n.t('postAreasStr.toastrSuccess'), `${res.data.name}${i18n.t('postAreasStr.toastrSuccess1')}`)
          resolve('success');
        })
        .catch(err => {
          dispatch(requestAreasFail(err));
          if (err.response.data.message === "Already in use") {
            toastr.error(i18n.t('postAreasStr.toastrError'), i18n.t('postAreasStr.toastrError2'))
          } else {
            toastr.error('Erro', err.response.data.message)
          }
          resolve('error');
        });
    })

  }
}

export const updateAreas = (index, body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(requestAreasStart());
      API.put('/areas/' + index, body)
        .then(res => {
          dispatch(updateAreasSuccess(res.data));
          toastr.success(i18n.t('updateAreasStr.toastrSuccess'), `${res.data.name}${i18n.t('updateAreasStr.toastrSuccess2')}`)
          resolve('success');
        })
        .catch(err => {
          dispatch(requestAreasFail(err));
          if (err.response.data.message === "Already in use") {
            toastr.error(i18n.t('updateAreasStr.toastrError'), i18n.t('updateAreasStr.toastrError1'))
          } else {
            toastr.error('Erro', err.response.data.message)
          }
          resolve('error');
        });
    })
  }
}
